import React from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import { Text } from '../../../components/Text';
import { TitleSections } from '../../../components/TitleSections';
import { setMaskTelefone } from '../../../helpers/utils';

export function DadosParaLeitura({ dadosMotorista }) {
  return <>
    <Col span={24} style={{ margin: '24px 0' }}>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text title="Nome" value={dadosMotorista?.nome || '-'} />
        </Col>
        <Col span={8}>
          <Text title="CPF" value={dadosMotorista?.cpfFormatado || '-'} />
        </Col>
        <Col span={8}>
          <Text
            title="Categoria"
            value={dadosMotorista?.motoristaCadastro?.categoriaCNH || '-'}
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="UF CNH"
            value={dadosMotorista?.motoristaCadastro?.ufEmissaoCNH || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="Nascimento"
            value={
              dadosMotorista?.dataNascimento
                ? moment(dadosMotorista?.dataNascimento).format('DD/MM/YYYY')
                : '-'
            }
          />
        </Col>
        <Col span={8}>
          <Text title="Telefone" value={dadosMotorista?.telefone || '-'} />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text title="Nome da Mãe" value={dadosMotorista?.nomeMae || '-'} />
        </Col>
        <Col span={8}>
          <Text title="Nome do Pai" value={dadosMotorista?.nomePai || '-'} />
        </Col>
        <Col span={8}>
          <Text
            title="Naturalidade"
            value={dadosMotorista?.naturalidade || '-'}
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text title="RG" value={dadosMotorista?.numeroRG || '-'} />
        </Col>
        <Col span={8}>
          <Text
            title="Data de Emissão RG"
            value={
              !!dadosMotorista?.dataEmissaoRG &&
              moment(dadosMotorista?.dataEmissaoRG).format('DD/MM/YYYY')
            }
          />
        </Col>
        <Col span={8}>
          <Text
            title="Formulário da CNH"
            value={
              dadosMotorista?.motoristaCadastro?.numeroFormularioCNH || '-'
            }
          />
        </Col>
        <Col span={8}>
          <Text
            title="Número de registro CNH"
            value={dadosMotorista?.motoristaCadastro?.numeroRegistroCNH || '-'}
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text
            title="Data de Emissão CNH"
            value={
              !!dadosMotorista?.motoristaCadastro?.dataEmissaoCNH &&
              moment(dadosMotorista?.motoristaCadastro?.dataEmissaoCNH).format(
                'DD/MM/YYYY'
              )
            }
          />
        </Col>
        <Col span={8}>
          <Text
            title="Validade CNH"
            value={
              (!!dadosMotorista?.motoristaCadastro?.dataValidadeCNH &&
                moment(
                  dadosMotorista?.motoristaCadastro?.dataValidadeCNH
                ).format('DD/MM/YYYY')) ||
              '-'
            }
          />
        </Col>
        <Col span={8}>
          <Text
            title="Código de segurança CNH"
            value={dadosMotorista?.motoristaCadastro?.codigoSegurancaCNH || '-'}
          />
        </Col>
        <Col span={8}>
          <Text
            title="Data de emissão da primeira CNH"
            value={
              !!dadosMotorista?.motoristaCadastro?.emissaoPrimeiraCNH &&
              moment(
                dadosMotorista?.motoristaCadastro?.emissaoPrimeiraCNH
              ).format('DD/MM/YYYY')
            }
          />
        </Col>
      </Row>
      <Row gutter={[2, 8]} style={{ marginBottom: '16px' }} justify="start">
        <Col span={8}>
          <Text title="UF RG" value={dadosMotorista?.ufrg || '-'} />
        </Col>
        <Col span={16}>
          <Text title="Endereço" value={dadosMotorista?.endereco || '-'} />
        </Col>
      </Row>
    </Col>
    {dadosMotorista?.referencias?.length > 0 && (
      <>
        <TitleSections title="Referências" />
        {dadosMotorista.referencias.map(referencia => (
          <Col span={24} style={{ margin: '24px 0' }}>
            <Row
              gutter={[2, 8]}
              style={{ marginBottom: '16px' }}
              justify="space-between"
            >
              <Col span={8}>
                <Text title="Nome" value={referencia?.nome || '-'} />
              </Col>
              <Col span={8}>
                <Text
                  title="Contato"
                  value={setMaskTelefone(referencia?.telefone) ?? '-'}
                />
              </Col>
              <Col span={8}>
                <Text
                  title="Tipo de referência"
                  value={referencia?.tipoReferencia || '-'}
                />
              </Col>
            </Row>
          </Col>
        ))}
      </>
    )}
         </>;
}
